module.exports = __webpack_public_path__ + "static/media/group.88e6e607.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group.svg
// module id = 2634
// module chunks = 0